export const FOUNDERS=(type)=>`/v2/guest/employees/${type}`;
export const ADMIN='/v2/guest/employees/administration';